/*
 * Copyright (c) 2023. American Express Company
 */

// third party
import React, { useEffect, useRef } from 'react';
import { ButtonSecondaryDark, ButtonTertiaryDark } from '@americanexpress/dls-react';

// models and services
import MentorButtonsViewModel from 'src/types/view-models/mentor-buttons.view.model';
import TrackingService from 'src/services/tracking.service';

// styles
import './Mentor.module.scss';
import { DLSSize } from 'src/types/dls-size.enum';
import Selectors from 'src/utils/selectors';

export default function MentorButtons({
    buttonOneText,
    buttonOneHandler,
    buttonTwoText,
    buttonTwoHandler
}: MentorButtonsViewModel): JSX.Element {
    const buttonRef = useRef(null);

    useEffect(() => {
        buttonRef.current.focus();
    });

    return (
        <div className="mentorButtonContainer">
            {buttonOneText && (
                <ButtonSecondaryDark
                    size={DLSSize.SMALL}
                    onClick={() => {
                        TrackingService.track({ button: 2 }).catch(console.error);
                        void buttonOneHandler();
                    }}
                    onKeyUp={(event: any) => {
                        if (event.keyCode === 13) {
                            event.preventDefault();
                            event.stopPropagation();
                            void buttonOneHandler();
                        }
                    }}
                    ref={buttonRef}
                    data-cy={Selectors.General.MENTOR_BUTTON_ONE}
                >
                    {buttonOneText}
                </ButtonSecondaryDark>
            )}
            {buttonTwoText && (
                <ButtonTertiaryDark
                    size={DLSSize.SMALL}
                    onClick={() => {
                        TrackingService.track({ button: 2 }).catch(console.error);
                        void buttonTwoHandler();
                    }}
                    data-cy="mentorButtonTwo"
                >
                    {buttonTwoText}
                </ButtonTertiaryDark>
            )}
        </div>
    );
}
